import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import Header from "../../Common/Header";
import { IoMdInformationCircle } from "react-icons/io";

const ExecutorIntro2 = () => {
  return (
    <>
      <Header />
      <div className="container">
        <div className="grid grid-cols-2 mt-[30px] max-lg:grid-cols-1">
          <div>
            <div className="text-[25px] font-semibold my-5">
              Choosing an executor?
            </div>
            <div>
              <div className="text-[20px] font-semibold">
                Choosing a family member or friend as an executor
              </div>
              <p className="my-3 text-slate-500">
                Acting as an executor is a huge responsibility. If you’d like to
                choose a friend or a family member, make sure they are:
              </p>
              <div className="my-4">
                <div>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Over 18
                  </p>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Trustworthy and
                    responsible
                  </p>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Good with finances
                    and complex paperwork
                  </p>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Able to dedicate the
                    time needed
                  </p>
                </div>
              </div>
              <p className="my-3 text-slate-500">
                You also should feel comfortable telling them you’ve chosen them
                to be your executor.
              </p>
            </div>
            <p className="my-5 text-slate-500"></p>
            <div>
              <div className="text-[20px] font-semibold">
                Choosing WillsGuru as an executor
              </div>
              <p className="my-3 text-slate-500">
                Settling an estate can be very stressful. WillsGuru’s Professional
                Executor service takes on all the work for your friends and
                family, so that they don’t have to worry.
              </p>
              <p className="my-3 text-slate-500">We will:</p>
              <div className="my-4">
                <div>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Save your family time
                    and stress
                  </p>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Protect them from any
                    liability
                  </p>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Work swiftly and
                    professionally to settle your affairs
                  </p>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Be fair and objective
                    in cases of conflict
                  </p>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Quote a guaranteed
                    fixed-fee upfront to save money
                  </p>
                </div>
              </div>
              <p className="my-3 text-slate-500">
                And, if your family decide they don’t need our service, we will
                let them take over, without any charge.
              </p>
            </div>
            
            <div className="bg-primary text-white p-5 rounded flex my-5" >
              <div>
                <IoMdInformationCircle className="infoIcon"/> 
              </div>
              <div className="ml-5">
                Even if you choose a family member or friend to settle your estate, they can (and probably will) ask a professional executor to help anyway.
              </div>
            </div>
            <div>
              <div className="text-[20px] font-semibold">
              Choosing WillsGuru + family and friends as executors
              </div>
              <p className="my-3 text-slate-500">
              Choosing both a professional executor and someone you know can be very effective. 
                It’s a good balance, with the professional executor usually handling all the stressful and complicated admin tasks while a friend or relative takes on the simpler stuff.
              </p>
            </div>
            
            <div className="border-b-2 my-5"></div>
            <div className="pt-5 flex justify-between items-center">
              <div className="flex  pb-5">
                <Link to={"/make-will-online/executors/intro-1"}>
                  <button className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500">
                    <FaAngleLeft />
                    Back
                  </button>
                </Link>
              </div>
              <div className="flex  pb-5">
                <Link to={"/make-will-online/executors/select"}>
                  <button className="bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-1">
                    Next <FaChevronRight />
                  </button>
                </Link>
              </div>
            </div>
          </div>

          <div>
            <div className="max-lg:hidden bg-no-repeat ">
              <div className="fixed top-[100px] w-[500px] right-[6%]">
                <img src="/assets/images/10.png" alt="mascot" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExecutorIntro2;
